import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { v_LocationDetailBus } from "./v_LocationDetailBus";
import { CommonValues } from "../static/CommonValues";

export class DispatchLaborBus extends BaseBus {
    constructor(busObj: BaseBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
        this.mgrApprovedDt = DateFunctions.getDate(this.mgrApprovedDt);
        this.startDate = DateFunctions.getDate(this.startDate);
        this.endDate = DateFunctions.getDate(this.endDate);
        this.sageDt = DateFunctions.getDate(this.sageDt);
    }
    CID(): any {
        return this.dispatchLaborId;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setParentId(id: any) {
        this.dispatchId = id;
    }
    get inFinance(): boolean {
        return DateFunctions.isValidDate(this.sageDt);
    }
    set inFinance(value: boolean) { }
    setFromForm(data: DispatchLaborBus) {
        super.setFromForm(data);
        this.calculateHours();
    }
    calculateHours() {
        this.hours = DateFunctions.dateDiffHours(this.startDate, this.endDate);
    }
    setBeforeSave() {
        this.startDate = DateFunctions.getDateTimeWithUTCOffset(this.startDate);
        this.endDate = DateFunctions.getDateTimeWithUTCOffset(this.endDate);
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

        this.mgrApprovedDt = DateFunctions.getDateTimeWithUTCOffset(this.mgrApprovedDt);
        this.sageDt = DateFunctions.getDateTimeWithUTCOffset(this.sageDt);
    }
    get canEdit(): boolean {
        return !this.originalMgrApproved;
    }

    dispatchLaborId: any;
    dispatchId: any;
    personId: any;
    laborTypeId: any;
    nonPaid: boolean;
    isHelper: boolean;
    timeTypeId: any;
    startDate: Date;
    endDate: Date;
    insertUserId: any;
    insertDt: Date;
    updateUserId: any;
    updateDt: Date;
    timeClassId: any;
    hrsApproved: boolean;
    afterPayroll: boolean;
    useLocationRate: boolean;
    hourlyRate: number;
    overheadRate: number;
    overheadPercent: number;
    mgrApproved: boolean;
    mgrApprovedDt: Date;
    mgrApprovedUserId: any;
    sageDt: Date;
    hours: number;
    originalMgrApproved: boolean;
    fullName: string;
    laborTypeName: string;
    timeTypeName: string;
    needsNote: boolean;
    get paidHours(): number {
        return this.nonPaid === true ? 0 : this.hours;
    }
    set paidHours(value: number) { }
    get workedHours(): number {
        return this.timeTypeId === CommonValues.TimeType_Work && !this.nonPaid ? this.hours : 0;
    }
    set workedHours(value: number) { }
    get travelHours(): number {
        return this.timeTypeId === CommonValues.TimeType_Travel && !this.nonPaid ? this.hours : 0;
    }
    set travelHours(value: number) { }
}

